import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react/components/Modal';

function OrderAndItemsModal({
  isOpen, stopId, isLoading, closeAction, idScreen, ...others
}) {
  const loadGrid = () => {
    new Greenmile.RouteDetail.LineItems.Grid(stopId, idScreen)
      .init();
  };

  return (
    <Modal
      isOpen={isOpen}
      closeModalFn={closeAction}
      title={Monet.I18n.getResourcesByKey('Greenmile.RouteDetails.StopDetailsOrderAndItemsPopup.Title')}
      subtitle={Monet.I18n.getResourcesByKey('Greenmile.RouteDetails.StopDetailsOrderAndItemsPopup.Subtitle')}
      style={{ width: '100%' }}
      className="route-details-line-items"
      data-testid="route-details-line-items"
      id="route-details-line-item"
      onAfterOpen={loadGrid}
      {...others}
    >
      <div data-testid={`lineItemsGrid_${stopId}`} id={`lineItemsGrid_${stopId}`}>
        <div className={`gridActions_${stopId}`} />
        <div id={`grid_${stopId}`} />
      </div>
    </Modal>
  );
}

OrderAndItemsModal.propTypes = {
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isOpen: PropTypes.bool.isRequired,
  idScreen: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  closeAction: PropTypes.func
};

export default OrderAndItemsModal;
